import React from 'react';
import { render } from 'react-dom';
import { Router, createMemoryHistory } from 'react-router';
import { Provider } from 'react-redux';
import { LocaleProvider } from 'antd';
import configuracioIdiomaHighCharts from './configuracioHighCharts';

import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

import routes from './routes';
import store from './store';

// configuració idioma (Català)
import caES from 'antd/lib/locale-provider/ca_ES';
import 'moment/locale/ca';

// Si el navegador no és compatible no existirà el div amb identificador root
const contenidor = document.getElementById('root');
if (contenidor) {
    //Es configura HighCharts perque mostri les etiquetes, dates i altres dades en català.
    configuracioIdiomaHighCharts();

    const history = createMemoryHistory('/');

    const aplicacio = <Provider store={store}>
        <LocaleProvider locale={caES}>
            <Router history={history} routes={routes}></Router>
        </LocaleProvider>
    </Provider>;

    render(aplicacio, contenidor);
}



// WEBPACK FOOTER //
// ./src/index.js